import { render, staticRenderFns } from "./HealthQuestionnaire.vue?vue&type=template&id=8f94a698"
import script from "./HealthQuestionnaire.vue?vue&type=script&lang=js"
export * from "./HealthQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports